import { z } from 'zod';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import {
  SteeringWalletBasicInfoFragment,
  Wallet_Steering_Attribute,
  Wallet_Steering_Operator,
} from '@occc/graphql';

const walletSteeringItemSchema = z.object({
  wallet: z
    .object({}, { required_error: IS_REQUIRED })
    .optional()
    .nullable() as unknown as z.ZodType<SteeringWalletBasicInfoFragment | undefined | null>,
  dimension: z.nativeEnum(Wallet_Steering_Attribute, { required_error: IS_REQUIRED }),
  operator: z.nativeEnum(Wallet_Steering_Operator, { required_error: IS_REQUIRED }),
  value: z.number({ required_error: IS_REQUIRED }),
});

const firstWalletSteeringItemSchema = z
  .object({
    wallet: z.object({}).optional().nullable() as z.ZodType<
      SteeringWalletBasicInfoFragment | undefined | null
    >,
    dimension: z.nativeEnum(Wallet_Steering_Attribute).optional().nullable(),
    operator: z.nativeEnum(Wallet_Steering_Operator).optional().nullable(),
    value: z.number().optional().nullable(),
  })
  .superRefine((data, ctx) => {
    if (!data.wallet) return;
    const result = walletSteeringItemSchema.safeParse(data);
    if (result.success) return;
    result.error.issues.forEach((issue) => {
      ctx.addIssue(issue);
    });
  });

export const walletSteeringItemsSchema = z
  .tuple([firstWalletSteeringItemSchema])
  .rest(walletSteeringItemSchema);
